<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <ng-container formGroupName="customObjectContext">
                    <wbo-custom-object-multi-select-edit-control formControlName="customObjects" [membershipTypeContext]="true" [(ngModel)]="model.data.customObjectContext.customObjects">
                    </wbo-custom-object-multi-select-edit-control>
                </ng-container>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>

